export const APP_UPLOAD_TIMEOUT_MS = 120000

export async function withUploadDeadline(request, parentSignal) {
  if (parentSignal?.aborted) throw new DOMException('Upload cancelled', 'AbortError')
  const controller = new AbortController()
  const cancel = () => controller.abort()
  parentSignal?.addEventListener('abort', cancel, { once: true })
  let timedOut = false
  let rejectCancelled
  const cancelled = new Promise((resolve, reject) => {
    rejectCancelled = () => reject(timedOut
      ? new Error('The upload timed out. Please try again.')
      : new DOMException('Upload cancelled', 'AbortError'))
    controller.signal.addEventListener('abort', rejectCancelled, { once: true })
  })
  const timer = setTimeout(() => { timedOut = true; cancel() }, APP_UPLOAD_TIMEOUT_MS)
  try {
    return await Promise.race([request(controller.signal), cancelled])
  } finally {
    clearTimeout(timer)
    parentSignal?.removeEventListener('abort', cancel)
    controller.signal.removeEventListener('abort', rejectCancelled)
  }
}
